import {
  AfterViewInit,
  Component,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { Dictionary } from "src/app/store/models/common_types";
import {
  VAIconRegistryService,
  doubleArrowRight,
} from "@va/core-library/icons";
import { NzTreeComponent } from "ng-zorro-antd/tree";
import { PharmaDataService } from "../pharma-data.service";
import { Subscription } from "rxjs";
import { phaseAbbreviations } from "../pharma-page.model";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { Store } from "@ngrx/store";
import { DatePipe } from "@angular/common";
@Component({
  selector: "app-audit-formulabar",
  templateUrl: "./audit-formulabar.component.html",
  styleUrls: ["./audit-formulabar.component.scss"],
  host: {
    class: "formulabar-component",
  },
  encapsulation: ViewEncapsulation.None,
})
export class AuditFormulabarComponent implements AfterViewInit {
  @ViewChild("nzTreeComponent")
  nzTreeComponent: NzTreeComponent;
  treeData: any;
  showFx = true;
  fbarExpanded = true;
  statusError = false;
  errorMessage = "";
  isLoading = false;
  dataAvailable = true;
  formulabarData: Dictionary<any> = {};
  disableAnchorLink = false;
  defaultExpandedKeys = ["expandFbar"];
  colName;
  isVisible = false;
  dpCallSubscriber: Subscription;
  phaseAbbr = phaseAbbreviations;
  totalCount;
  loadTree = true;
  columMapper = {
    indications: "Indications by Phase",
    moa: "Mechanism of Action",
    approval_date: "Approval Date",
    target: "Target",
    drug_type: "Drug Type",
    api: "API",
    delivery_mechanism: "Delivery Mechanism",
    expiry_date: "Expiry Date",
  };

  dpParamsSubscription: Subscription;
  constructor(
    private iconRegistryService: VAIconRegistryService,
    private dataService: PharmaDataService,
    private store: Store<AppState>,
  ) {
    this.iconRegistryService.registerIcons([doubleArrowRight]);
  }

  ngAfterViewInit(): void {
    this.dpCallSubscriber = this.dataService.dpClicked.subscribe(
      ({ selectedCell, api_response, auditCols, isLoading }) => {
        if (!selectedCell) return;
        this.isLoading = isLoading;
        if (isLoading) {
          return;
        }
        this.colName = selectedCell.substring(selectedCell.indexOf("|") + 1);
        if (auditCols.indexOf(this.colName) !== -1) {
          this.treeData = this.formatDataForTree(
            api_response && api_response.data ? api_response.data : [],
          );
          this.fbarExpanded = true;
        }
      },
    );

    this.dpParamsSubscription = this.store
      .select(stateGetter("globalSubheader", "dpParams"))
      .subscribe((data: Dictionary<any>) => {
        if (!data || Object.keys(data).length === 0) {
          this.treeData = this.formatDataForTree([]);
        }
      });
  }

  private formatDataForTree(data) {
    if (data && data.length === 0) {
      this.loadTree = false;
      return null;
    }
    this.loadTree = true;
    this.totalCount = data.length;
    const rootNodeData = data.slice(0, 3);
    const rootTitleInfo = this.getRootSummary(rootNodeData);
    const rootSummary = {
      title: " ", // Provide a suitable summary for the root node
      expanded: true, // Set to false to make the root node initially collapsed
      isExpanded: true,
      children: this.getRootChildren(data),
      ColumnName: rootTitleInfo["modifiedColumnName"],
      summary: rootTitleInfo["displayData"],
    };

    return [rootSummary];
  }

  getRootSummary(rootNodeData: any[]): object {
    let data = null;
    if (this.colName === "indications")
      data = rootNodeData
        .map((item) => `${item.phase}: ${item.name}`)
        .join(", ");
    else if (
      this.colName === "approval_date" ||
      this.colName === "expiry_date"
    ) {
      data = rootNodeData
        .map((item) => {
          const date = new Date(item.name);
          return new DatePipe("en-US").transform(date, "dd-MMM-yyyy");
        })
        .join(", ");
    } else
      data = rootNodeData
        .map((item) => {
          return item.name;
        })
        .join(", ");
    const modifiedColumnName = this.columMapper[this.colName];
    const displayData =
      this.totalCount > 3 ? `${data} (+${this.totalCount - 3})` : `${data}`;
    return { displayData, modifiedColumnName };
  }

  getRootChildren(rootNodeData: any[]): any[] {
    if (this.colName === "approval_date" || this.colName === "expiry_date") {
      return rootNodeData.map((item) => ({
        phase: item.phase,
        name: new DatePipe("en-US").transform(
          new Date(item.name),
          "dd-MMM-yyyy",
        ),
        link: item.url,
        date: item.date
          ? new DatePipe("en-US").transform(new Date(item.date), "dd-MMM-yyyy")
          : item.date,
        shortname: item.shortname,
        isLeaf: true,
        title: " ",
      }));
    }

    return rootNodeData.map((item) => ({
      phase: item.phase,
      name: item.name,
      link: item.url,
      date: item.date
        ? new DatePipe("en-US").transform(new Date(item.date), "dd-MMM-yyyy")
        : item.date,
      shortname: item.shortname,
      isLeaf: true,
      title: " ",
    }));
  }

  isRootNode(node: any): boolean {
    if (node.level === 0) {
      return true;
    }

    return false;
  }

  onExpandRootNode(rootNode: any): void {
    if (rootNode.expanded === undefined) {
      //by default fbar is expanded
      rootNode.expanded = true;
    }
    rootNode.expanded = !rootNode.expanded;
    rootNode.isExpanded = rootNode.expanded;
    this.fbarExpanded = rootNode.isExpanded;
  }

  onFbarClick(rootNode: any) {
    if (this.isRootNode(rootNode)) {
      this.onExpandRootNode(rootNode);
    }
  }
  redirectToCompanyPage(url) {
    window.open(url, "_blank");
  }

  // isEscKeyPressed(event: KeyboardEvent,rootNode?: any) {
  //   let isEscape = false;
  //   isEscape =
  //     "key" in event ? event.key === "Escape" || event.key === "Esc" : isEscape;
  //   // isEscape = (event.which == 27);
  //   if (isEscape ) {
  //     const node: NzTreeNode =this.nzTreeComponent.getTreeNodeByKey("expandFbar");
  //     rootNode.expanded = false;
  //     this.fbarExpanded = false;
  //     // this.logFbarAction(
  //     //   {},
  //     //   this.ticker,
  //     //   this.formulabarData.cut,
  //     //   "FORMULA_BAR_CLOSED",
  //     //   this.formulabarData.source,
  //     //   "KEYBOARD_SHORTCUT",
  //     // );
  //   }
  // }

  ngOnDestroy() {
    if (this.dpCallSubscriber) {
      this.dpCallSubscriber.unsubscribe();
    }
    if (this.dpParamsSubscription) {
      this.dpParamsSubscription.unsubscribe();
    }
  }
}
